import { s__ } from '~/locale';

/**
 * Summarising a conversation so it fits back into the context window.
 *
 * @type {import('../../services/plugin_registry').DuoChatPlugin}
 */
export const compactPlugin = {
  name: 'compact',
  slashCommands: [
    {
      getCommands: () => [
        {
          /* eslint-disable-next-line @gitlab/no-hardcoded-urls -- a slash command, not a URL */
          name: '/compact',
          description: s__('DuoAgenticChat|Summarize and compact this conversation'),
          shouldSubmit: false,
          startOnly: true,
        },
      ],
    },
  ],
};
